export const baseUrl = process.env.REACT_APP_FLEETCONFIGURATION_URL;
//export const baseUrl = "http://localhost:8000/services/fleetconfiguration";

export const fleetconfigurationUrls = {
    subfleets: {
        baseUrl: () => `${baseUrl}/subfleets/subfleets/`,
        activate: () => `${fleetconfigurationUrls.subfleets.baseUrl()}activate/`,
        share: () => `${fleetconfigurationUrls.subfleets.baseUrl()}share/`
    },
    sharedSubfleets: {
        baseUrl: () => `${baseUrl}/subfleets/shared/`,
        import: () => `${fleetconfigurationUrls.sharedSubfleets.baseUrl()}import-subfleet/`
    }
};
